import React from 'react'
import { connect } from 'react-redux'


const styles = {
  videoWrapper: {
    textAlign: 'center',
    margin: '10px',
  },
  video: {
    height: 'auto',
    width: '80%',
  },
}

class VideoElement extends React.Component {

  render() {
    const { element } = this.props
    return (
      <div style={styles.videoWrapper}>
        <video style={styles.video} src={element.media_url} controls ></video>
      </div>
    )
  }

}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = () => ({
})


export default connect(mapStateToProps, mapDispatchToProps)(VideoElement)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/FormPage/PageElement/VideoElement/index.jsx